import { ScheduleShiftNavigator } from 'components/ScheduleShiftNavigator'
import { Modal } from 'ui'

type ScheduleShiftModalProps = {
  worker: {
    id: number
    name?: string
  } | null
  isOpen: boolean
  onClose: () => void
}

export function ScheduleShiftModal({
  worker,
  isOpen = false,
  onClose,
}: ScheduleShiftModalProps) {
  return (
    <Modal width={[1, 680]} open={isOpen} onClose={onClose}>
      <ScheduleShiftNavigator worker={worker} />
    </Modal>
  )
}
